<template>
  <div class="list-item" @click="onClickRow">
    <v-img :lazy-src="url" max-height="75" max-width="75" :src="url"></v-img>


    <div class="">{{ image_title }}<KeywordRow :keywords="keywords" /></div>
    <div class="">{{ image_text }}</div>
    <div class="">{{ createdDate }}</div>
    <div class="">{{ updatedDate }}</div>
    <div class="">{{ updated_by }}</div>
  </div>
</template>

<script>
import { dateParseJustDate as dateParse } from '../../lib/misc'
import { getColor } from '@/assets/data/colors'
import KeywordRow from '@/components/shared/KeywordRow.vue'

export default {
  name: 'LatestPagesListItem',
  props: {
    id: { type: Number },
    image_publish: { type: String },
    image_url: { type: String },
    image_type: { type: String },
    image_title: { type: String },
    image_text: { type: String },

    created_at: { type: String },
    updated_at: { type: String },
    updated_by: { type: String },
    image_keywords:{type:String}
  },
  components: {
    KeywordRow,
  },
  computed: {
    createdDate() {
      return dateParse(this.created_at)
    },
    updatedDate() {
      return dateParse(this.updated_at)
    },
    url() {
      return `${process.env.VUE_APP_IMAGE_BACKEND}/170/${this.id}.jpg`
    },
    color() {
      return getColor(this.image_publish)
    },
    keywords(){
      return this.image_keywords
    }
  },
  methods: {
    onClickRow() {
      this.$router.push({ name: 'Image', params: { id: this.id } })
    },
  },
}
</script>

<style lang="less" scoped>
.list-item {
  display: grid;
  grid-template-columns: 75px 1fr 140px 140px;
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;

  padding: 6px 10px;
  border-bottom: #ccc 1px solid;
  background-color: #fff;
  cursor: pointer;
  &:hover {
    background-color: rgb(245, 245, 245);
  }

  .chip {
    display: flex;
    justify-content: center;
  }

  .page-title {
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .page-date {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-left: 10px;
    white-space: nowrap;
  }
}
</style>
